import {createReducer} from 'redux-act';

import {
    ALBUMS_FETCH_DATA_INIT,
    ALBUMS_FETCH_DATA_SUCCESS,
    ALBUM_FETCH_DATA_SUCCESS,
    ALBUMS_FETCH_DATA_FAIL,
    ALBUMS_DELETE_ALBUM_INIT,
    ALBUMS_DELETE_ALBUM_SUCCESS,
    ALBUMS_DELETE_ALBUM_FAIL,
    ALBUMS_CREATE_ALBUM_INIT,
    ALBUMS_CREATE_ALBUM_SUCCESS,
    ALBUMS_CREATE_ALBUM_FAIL,
    ALBUMS_MODIFY_ALBUM_INIT,
    ALBUMS_MODIFY_ALBUM_SUCCESS,
    ALBUMS_MODIFY_ALBUM_FAIL,
    ALBUMS_CLEAN_UP,
    ALBUMS_CLEAR_DATA_LOGOUT,
} from 'state/actions/albums';

const initialState = {
    data: [],
    album: null,
    total: 0,
    page: 1,
    loading: false,
    error: null,
    success: false,
    deleted: false,
    sortConfig: {
      attribute: 'name',
      order: 'asc'
    }
};

export const albumsReducer = createReducer(
    {
        [ALBUMS_FETCH_DATA_INIT]: () => ({
            ...initialState,
            loading: true,
        }),
        [ALBUM_FETCH_DATA_SUCCESS]: (state, payload) => ({
            ...state,
            album: payload.album,
            loading: false,
            error: null,
        }),
        [ALBUMS_FETCH_DATA_SUCCESS]: (state, payload) => ({
            ...state,
            data: payload.data,
            total: payload.total,
            page: payload.page,
            sortConfig: payload.sortConfig,
            loading: false,
            error: null,
        }),
        [ALBUMS_FETCH_DATA_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [ALBUMS_DELETE_ALBUM_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [ALBUMS_DELETE_ALBUM_SUCCESS]: (state, payload) => ({
            ...state,
            data: state.data.filter((elem) => elem.id !== payload.id),
            loading: false,
            error: null,
            deleted: true,
        }),
        [ALBUMS_DELETE_ALBUM_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [ALBUMS_CREATE_ALBUM_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [ALBUMS_CREATE_ALBUM_SUCCESS]: (state, payload) => ({
            ...state,
            album: payload.album,
            data: state.data.concat(payload.album),
            loading: false,
            error: null,
            success: true,
        }),
        [ALBUMS_CREATE_ALBUM_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [ALBUMS_MODIFY_ALBUM_INIT]: (state) => ({
            ...state,
            loading: true,
        }),
        [ALBUMS_MODIFY_ALBUM_SUCCESS]: (state, payload) => ({
            ...state,
            data: !state.data
                ? []
                : state.data.map((elem) => {
                    if (elem.id === payload.id) {
                        return {
                            name: payload.album.name,
                            id: payload.id,
                            img: payload.album.img,
                            artists: payload.album.artists,
                            genres: payload.album.genres,
                            songs: payload.album.songs,
                            createdAt: payload.album.createdAt,
                        };
                    }
                    return elem;
                }),
            loading: false,
            error: null,
            success: true,
        }),
        [ALBUMS_MODIFY_ALBUM_FAIL]: (state, payload) => ({
            ...state,
            loading: false,
            error: payload.error,
        }),
        [ALBUMS_CLEAN_UP]: (state) => ({
            ...state,
            loading: false,
            error: null,
            success: false,
            deleted: false,
        }),
        [ALBUMS_CLEAR_DATA_LOGOUT]: () => ({
            ...initialState,
        }),
    },
    initialState
);
